import { ReactNode, useMemo } from 'react';

import { FlexAligner, Tooltip, TrafficLight, Typography } from '@scaleaq/scaleui';

import { useSiteNameAndConnectionState } from '@/components/siteNameAndConnectionState/useSiteNameAndConnectionState.tsx';
import { WidgetHealthIssue } from '@/types.ts';
import { responsive, sortWidgetHealthIssuesByPriority } from '@/utils';

export const SiteNameAndConnectionState = ({
  children,
  healthIssues,
  cloudBacked = false,
  zIndex,
}: {
  children: ReactNode;
  healthIssues?: WidgetHealthIssue[];
  cloudBacked?: boolean;
  zIndex?: number;
}) => {
  const nonOkHealthIssues = useMemo(
    () =>
      sortWidgetHealthIssuesByPriority(
        (healthIssues ?? []).filter(
          issue => issue.severity !== 'ok' && issue.message.trim().length > 0
        )
      ),
    [healthIssues]
  );

  const { trafficLightType, displayText, tooltipText } = useSiteNameAndConnectionState({
    healthIssues: nonOkHealthIssues,
    cloudBacked,
  });

  return (
    <FlexAligner
      alignment={'center'}
      gap={responsive.spacing['2xlarge']}
      fullWidth={false}
      style={{ zIndex }}
    >
      <Tooltip
        tooltip={
          <Typography style={{ whiteSpace: 'pre-line', maxWidth: '32rem' }} type='body_small'>
            {tooltipText}
          </Typography>
        }
      >
        <FlexAligner alignment={'center'} gap={responsive.spacing['medium']}>
          <TrafficLight type={trafficLightType} />
          <Typography type='body_small' style={{ whiteSpace: 'nowrap' }} disabled>
            {displayText}
          </Typography>
        </FlexAligner>
      </Tooltip>
      {children}
    </FlexAligner>
  );
};
